module.exports = __webpack_public_path__ + "static/media/logo_circle.18a26a28.png";